export class CyberSecurity {
    number: string
    url: string
    constructor(number: string = null, url: string = null) {
        this.number = number;
        this.url = url;
    }
}